import { toast, type ExternalToast } from "sonner";
import { Toast } from "./toast";

const DEFAULT_DURATION = 4000;

export interface AddToastOptions {
  title?: string;
  message: string;
  type: "success" | "error" | "warning" | "info";
  duration?: number | false;
  position?:
    | "top-left"
    | "top-right"
    | "top-center"
    | "bottom-left"
    | "bottom-right"
    | "bottom-center";
}

const addToast = ({
  title,
  message,
  type,
  duration = DEFAULT_DURATION,
  position = "top-center",
}: AddToastOptions): string | number => {
  const options: ExternalToast = {
    duration: duration === false ? Infinity : duration,
    position,
  };

  return toast.custom(
    (id) => (
      <Toast
        closeToast={() => toast.dismiss(id)}
        message={message}
        title={title}
        type={type}
      />
    ),
    options,
  );
};

const toastService = {
  success: (
    message: string,
    options?: Omit<AddToastOptions, "type" | "message">,
  ) => addToast({ message, type: "success", ...options }),

  error: (
    message: string,
    options?: Omit<AddToastOptions, "type" | "message">,
  ) => addToast({ message, type: "error", ...options }),

  warning: (
    message: string,
    options?: Omit<AddToastOptions, "type" | "message">,
  ) => addToast({ message, type: "warning", ...options }),

  info: (
    message: string,
    options?: Omit<AddToastOptions, "type" | "message">,
  ) => addToast({ message, type: "info", ...options }),

  dismiss: (toastId?: string | number) => toast.dismiss(toastId),

  dismissAll: () => toast.dismiss(),
};

export { addToast, toastService };
